// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__HPW1r","location":"Footer_location__GVw5z","socialIcons":"Footer_socialIcons__NBzTr"};